<template>
  <div>
    <v-flex xs6 class="animated fadeIn delay-1s">
      <h5 class="text-uppercase text-xs-left ml-3 pt-3">VOUCHER</h5>
    </v-flex>
    <v-layout class="animated fadeIn delay-1s px-2">
      <v-flex xs12>
        <v-card class="pa-1" min-height="65vh">
          <v-layout class="animated fadeIn delay-0.5s">
            <v-flex>
              <v-autocomplete
                style="padding: 0"
                class="px-2 mt-3 fadeIn delay-1s"
                v-model="contact"
                :search-input.sync="search"
                no-filter
                :items="items"
                :loading="isLoading"
                color="#099AB1"
                hide-selected
                item-text="description"
                placeholder="Buscar..."
                prepend-inner-icon="search"
                return-object
                @input="getVouchers"
              >
                <template v-slot:item="data">
                  <v-list-tile-avatar class="pl-2">
                    <div
                      v-lazy-container="{
                        error: 'https://s3.amazonaws.com/konselior/blankwhats.jpg',
                        loading: 'https://s3.amazonaws.com/konselior/blankwhats.jpg'
                      }"
                    >
                      <img
                        class="avatarImg"
                        :data-src="data.item.celular.whatsapp.picture"
                        v-if="data.item.celular && data.item.celular.whatsapp"
                      />
                      <img
                        class="avatarImg"
                        :data-src="'https://s3.amazonaws.com/konselior/blankwhats.jpg'"
                        v-if="!data.item.celular || !data.item.celular.whatsapp"
                      />
                    </div>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title
                      v-html="`${data.item.nome} ${data.item.sobrenome}`"
                      class="alignSelect"
                    ></v-list-tile-title>
                    <v-list-tile-sub-title
                      v-html="`Número: ${data.item.celular}`"
                    ></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </v-autocomplete>
            </v-flex>
          </v-layout>
          <div
            class="text-xs-center animated fadeIn delay-1s"
            style="margin: 0"
            v-show="voucherPhones.length <= 0 && contact"
          >
            Cliente não possui vouchers 😢
          </div>
          <v-card-text v-if="contact">
            <v-layout row v-for="voucherPhone of voucherPhones" :key="voucherPhone.id">
              <v-flex xs12 sm12 md12 lg12>
                <v-card
                  :elevation="
                    !voucherPhone.used && isValidVoucher(voucherPhone.begin, voucherPhone.end)
                      ? 4
                      : 0
                  "
                  :color="
                    voucherPhone.used || !isValidVoucher(voucherPhone.begin, voucherPhone.end)
                      ? '#F1F1F1'
                      : ''
                  "
                  class="py-4 px-4"
                >
                  <v-layout row>
                    <v-flex>
                      <v-layout>
                        <v-flex>
                          <v-icon color="#000000de">far fa-flag</v-icon>
                          <strong class="pl-3">{{ voucherPhone.key }}</strong>
                        </v-flex>
                      </v-layout>
                      <v-layout class="mt-2">
                        <v-flex xs12 sm12 md12 lg12>
                          <v-icon color="#000000de">far fa-calendar-alt</v-icon>
                          <span class="pl-3"
                            >{{ voucherPhone.begin | formatDate }} -
                            {{ voucherPhone.end | formatDate }}</span
                          >
                        </v-flex>
                      </v-layout>
                      <v-layout class="mt-2">
                        <v-flex xs12 sm12 md12 lg12>
                          <v-icon color="#000000de">fas fa-info-circle</v-icon>
                          <span class="pl-3 text-justify">{{ voucherPhone.description }}</span>
                        </v-flex>
                      </v-layout>
                      <v-layout class="mt-2">
                        <v-flex xs12 sm12 md12 lg12>
                          <v-btn
                            :outline="
                              !voucherPhone.used &&
                              isValidVoucher(voucherPhone.begin, voucherPhone.end)
                            "
                            style="text-transform: none !important;"
                            :class="
                              !isValidVoucher(voucherPhone.begin, voucherPhone.end)
                                ? 'disable-events'
                                : ''
                            "
                            :color="
                              !isValidVoucher(voucherPhone.begin, voucherPhone.end)
                                ? '#777777  '
                                : '#099AB1'
                            "
                            @click="validateVoucher(voucherPhone)"
                            depressed
                            block
                            dense
                            :disabled="voucherPhone.used"
                          >
                            <span
                              v-show="
                                !voucherPhone.used &&
                                  isValidVoucher(voucherPhone.begin, voucherPhone.end)
                              "
                              >Validar Voucher</span
                            >
                            <span v-show="voucherPhone.used">Voucher Utilizado</span>
                            <span
                              style="color: white"
                              v-show="
                                !voucherPhone.used &&
                                  !isValidVoucher(voucherPhone.begin, voucherPhone.end)
                              "
                              >Prazo Expirado</span
                            >
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-card-actions class="animated fadeIn delay-0.5s">
      <v-spacer></v-spacer>
    </v-card-actions>
  </div>
</template>

<script>
import format from 'date-fns/format';
import { APIService } from '@/resources/campanha.js';
import { mapState, mapActions } from 'vuex';
import Fuse from 'fuse.js';
import phoneSanitizer from '@/resources/sanitizers/phone.js';

const api = new APIService();

export default {
  data() {
    return {
      isLoading: false,
      user: this.$auth.user,
      used: false,
      customer: {},
      matches: [],
      voucherPhones: [],
      vouchers: [],
      contact: null,
      fuse: null,
      search: '',
      lastLetter: null,
      isLoading: false,
    };
  },
  filters: {
    formatDate: val => format(val, 'DD/MM/YY'),
  },
  methods: {
    getCustomer() {
      api.getCustomerBySellerId(this.user.sub).then((customer) => {
        this.customer = customer;
      });
    },
    async validateVoucher(voucher) {
      voucher.used = true;
      const res = await api.saveVoucherPhone(voucher);
    },
    async getVouchers() {
      this.isLoading = true;
      const sanitizedPhone = await phoneSanitizer(this.contact.celular);
      const { phoneArea } = sanitizedPhone;
      const { phone } = sanitizedPhone;
      api
        .getVouchersByPhoneAreaAndPhoneAndCustomerId(phoneArea, phone, this.customer.id)
        .then(async (voucherPhones) => {
          await voucherPhones.forEach(async (voucherPhone) => {
            const voucher = await api.getVoucherById(voucherPhone.voucherId);
            this.$set(voucherPhone, 'description', voucher.description);
          });
          this.voucherPhones = voucherPhones;
        });
      this.isLoading = false;
    },
    isValidVoucher(begin, end) {
      const today = new Date().getTime();
      const beginFormatted = new Date(begin);
      const endFormatted = new Date(end);
      return today >= beginFormatted.getTime() && today <= endFormatted.getTime();
    },
  },
  computed: {
    items() {
      const people = this.matches.map((entry) => {
        const description = `${entry.nome ? entry.nome : ''} ${
          entry.sobrenome ? entry.sobrenome : ''
        }`;
        return Object.assign({}, entry, { description });
      });

      return people;
    },
    ...mapState(['agendaMarca']),
  },
  watch: {
    search(a) {
      if (this.fuse && a) {
        this.matches = this.fuse.search(a.trim());
      }
    },
  },
  mounted() {
    this.getCustomer();

    const options = {
      shouldSort: true,
      threshold: 0.6,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: ['nome', 'sobrenome', 'celular'],
    };
    this.fuse = new Fuse(this.agendaMarca, options);
  },
};
</script>

<style scoped>
.v-card {
  box-shadow: none;
  border-radius: 10px;
}

.theme--light.v-sheet {
  border: 1px solid #e0e0e0;
}
</style>

<style>
.v-input__append-outer .v-icon,
.v-input__prepend-outer .v-icon {
  font-size: 18px !important;
}
.disable-events {
  pointer-events: none;
}
.marginToBottom {
  width: 100%;
  margin-bottom: 175px;
}
</style>
